import React, { useEffect } from "react";
import { useScrollToTop } from "../components/hooks/scrollToTopHook";
import { useServices } from "../contexts/ServiceContext";
import { BespokePickOverviewView } from "../views/BespokePickOverviewView";
import { useApplication } from "../contexts/ApplicationContext";
import { useEvent } from "../contexts/EventContext";
import { MixPanelEventEnum, useMixpanel } from "../utils/analytics";

export const BespokePickOverviewController = (): JSX.Element => {
    const {
        appDispatch,
        appState: { freeplayFocusedExperience },
    } = useApplication();
    const { currentEntry, currentEvent } = useEvent();
    const { fpUser } = useServices();
    useScrollToTop();
    useEffect(() => {
        if (fpUser || freeplayFocusedExperience) {
            appDispatch({ type: "setLoginButtonVisible", buttonVisible: false, buttonString: "" });
        } else {
            appDispatch({ type: "setLoginButtonVisible", buttonVisible: true, buttonString: "Login to Submit Picks" });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [fpUser, freeplayFocusedExperience]);
    useMixpanel(
        fpUser ? MixPanelEventEnum.PICK_OVERVIEW_SCREEN_VIEWED : MixPanelEventEnum.UNAUTHED_OVERVIEW_SCREEN_VIEWED,
        currentEvent?.id ?? -1,
    );
    if (!currentEvent) {
        return <p>Loading</p>;
    }

    return <BespokePickOverviewView event={currentEvent} entry={currentEntry} />;
};
